import anime from 'animejs';
import { Random } from "random-js";

class SlotMachine {

    constructor() {
        this.state = {
            sectorTick: 1,
            isWorked: false,
            enabledSound: true,
            wheelProgress: 0,
            meta: {
                wheelAngle: 0
            }
        };

        this.node = {
            machine: document.querySelector('.js-machine'),
            highlighter: null,
            wheel: null,
        };

        this.class = {
            showHighlighter: 'slot-monitor__highlighter--show',
            flickerHighlighter: 'slot-monitor__highlighter--flicker',
        };

        // this.sound = {
        //     wheel: document.getElementById('sound-wheel'),
        //     fanfar: document.getElementById('sound-fanfar')
        // };

        this.cubicBezier = '1, 1.1, 1, 1.005';
        this.wheelsNumber = 5;
        this.slotsInWheel = 40;
        this.slotNumber = 10;
        this.slotWinNumber = 6;
        this.durationOffset = 300;
        this.duration = 2000;
        this.ticker;

        this.init();
    }

    init() {
        // this.sound.fanfar.volume = 0.5;
        // this.sound.wheel.volume = 0.3;

        this.render();
    }

    render() {
        const random = new Random();

        /**
         * 
         * TODO:
         * refactor on createElement and fragments
         * 
         */

        let wheelTpl = '';

        for (let i = 0; i < this.wheelsNumber; i++) {
            let slotTpl = '';

            for (let j = 0; j < this.slotsInWheel; j++) {
                let slot = random.integer(1, this.slotNumber);

                if (j + 1 === 2) {
                    slot = this.slotWinNumber;
                }

                let style = '';

                if (j >= this.slotsInWheel - 3) {
                    style = 'slot-monitor-column__item--offset';
                }

                slotTpl += `
                    <div class="slot-monitor-column__item ${style ? style : ''}">
                        <div class="slot-monitor-item slot-monitor-item--${slot}"></div>
                    </div>
                `;
            }

            wheelTpl += `
                <div class="slot-monitor__column">
                    <div class="slot-monitor-column js-wheel">
                        ${slotTpl}
                    </div>
                </div>
            `;
        }

        wheelTpl += `<div class="slot-monitor__highlighter js-highlighter"></div>`;

        this.node.machine.innerHTML = wheelTpl;

        this.node.wheel = this.node.machine.querySelectorAll('.js-wheel');
        this.node.highlighter = this.node.machine.querySelector('.js-highlighter');

        let timeout = 800;
        this.node.wheel.forEach((wheel) => {
            let slots = wheel.querySelectorAll('.slot-monitor-column__item--offset');

            for (let i = slots.length - 1; i >= 0; i--) {
                setTimeout(() => {
                    slots[i].style.transition = '.2s ease';
                    slots[i].classList.remove('slot-monitor-column__item--offset');
                }, timeout);

                timeout = timeout + 100;
            }
        });
    }

    playSound(slug) {
        let promise;

        switch (slug) {
            case 'wheel':
                this.sound.wheel.pause();
                this.sound.wheel.currentTime = 0;
                promise = this.sound.wheel.play();
                break;
            case 'fanfar':
                this.sound.fanfar.pause();
                this.sound.fanfar.currentTime = 0;
                promise = this.sound.fanfar.play();
                break;
        }

        if (promise !== undefined) {
            promise.catch(error => {
                console.log('Play sound (' + slug + ') error: ' + error);
            });
        }
    }

    sendEvent(detail) {
        let event = new CustomEvent('wheelGame', {
            detail: detail
        });

        window.dispatchEvent(event);
    }

    rotateWheel(number) {
        let slotHeight = document.querySelector('.slot-monitor-column__item').scrollHeight;
        let scrollHeight = slotHeight * this.slotsInWheel;
        let wheelHeight = scrollHeight - slotHeight * 3;

        let rotate = wheelHeight + 12;
        let duration = this.duration - (this.wheelsNumber - this.durationOffset * (number + 1));

        this.node.wheel[number].style.transition = 'transform ' + duration + 'ms cubic-bezier(' + this.cubicBezier + ')';
        this.node.wheel[number].style.transform = 'translateY(' + rotate + 'px)';
    }

    rotateBegin() {
        this.state.isRotated = true;
        
        this.sendEvent({
            status: 'begin'
        });
    }

    rotateComplete() {
        setTimeout(
            this.rotateFinishing.bind(this)
        , 500);
    }

    rotateFinishing() {

        function highlight() {
            this.node.highlighter.classList.add(this.class.showHighlighter);
            this.node.highlighter.classList.add(this.class.flickerHighlighter);

            this.node.wheel.forEach((e) => {
                e.querySelectorAll('.slot-monitor-column__item')[1].classList.add('slot-monitor-column__item--flicker');
            });

            // this.playSound('fanfar');
        }

        function rotate() {
            this.node.highlighter.style.transform = 'rotateX(' + 360 + 'deg)';
            this.node.highlighter.style.transition = '.4s ease';

            this.node.wheel.forEach((e) => {
                e.querySelectorAll('.slot-monitor-column__item')[1].style.transition = '.4s ease';
                e.querySelectorAll('.slot-monitor-column__item')[1].style.transform = 'rotateX(' + 360 + 'deg)';
            });
        }

        setTimeout(highlight.bind(this), 1500);
        setTimeout(rotate.bind(this), 3000);

        this.state.isRotated = false;

        this.sendEvent({
            status: 'complete'
        });
    }

    start() {
        if (!this.state.isWorked) {

            for (let i = 0; i < this.wheelsNumber; i++) {                
                this.rotateWheel(i);
            }

            let amineOptions = {
                targets: this.state.meta,
                duration: this.duration,
                easing: 'cubicBezier(' + this.cubicBezier + ')',
                wheelAngle: this.state.wheelAngle,
                begin: () => this.rotateBegin(),
                complete: () => this.rotateComplete()
            };

            anime(amineOptions);
        } else {
            this.sendEvent({
                status: 'rotation'
            });  
        }
    }
}

export default SlotMachine;